import { utils, confirmDelivery, bindPannel, updateTotalAmount, checkShippingGroup, changeDelivery } from './shipping-utils';
import { relayPointGeneric } from './relay-point-generic';
import { homeAddress, initHomeselect } from './home-delivery';
import { addNewAddress } from './shipping-address-book';
import { pickup, initPickUpSelect, changePickupActor } from './pickup-in-store';
import { search } from './relay-point';
import { init as initSelect } from '../../../commons/select';
import { init as initStateButtonsHandler } from '../state-button-handler';
import { init as initShippingReex } from './shipping-reex';

export function init(){
  const form = cube.$id('js-checkout-shipping');

  $(form).validate($.extend(null, $.validator.cubeOptions, {
    ignore: ':hidden:not(.selectpicker)',
    rules: {
      title: { extendedalphanumeric: true },
      name: 'extendedalphanumeric',
      surname: 'extendedalphanumeric',
      mobile : { mobile: true },
      landline : { mobile: true }
    },
    messages: {
      name: {
        required: window.Messages('shippingAddress.error.nameRequired')
      },
      mobile: {
        required: window.Messages('shippingAddress.error.mobileRequired')
      },
      landline: {
        required: window.Messages('shippingAddress.error.landlineRequired')
      },
      streetName: {
        required: window.Messages('shippingAddress.error.streetNameRequired')
      },
      title: {
        required: window.Messages('shippingAddress.error.titleRequired')
      }
    }
  }));

  form.on('keypress', event => {
    if (event.keyCode === 13)
      event.preventDefault();
  });

  // Listen for change on input radio
  $('body').on('change', '[name="delivery-type"]', changeDelivery);

  // Listen for change on input radio C&C 1h
  $('body').on('change', '[name="pickup-choice-one"]', changePickupActor);

  // Update payment button state
  $('body').on('click', '.dkt-checkout-primary-button', confirmDelivery);

  //Add new address - home delivery
  $('body').on('click', '.add-item', addNewAddress);

  initHomeselect();
  initPickUpSelect();

  // Commons handlers
  utils();

  // Pannels handler
  bindPannel();

  // Update total amount
  updateTotalAmount();

  //
  homeAddress();

  initSelect();

  // Init Pick up in store
  pickup();

  initStateButtonsHandler();

  checkShippingGroup();

  // refresh #checkout-order-summary cartridge when receiving related event
  cube.event.on('checkout:refresh-order-summary', () => {
    cube.cartridge('checkout-order-summary').after(() => {
      updateTotalAmount();
      checkShippingGroup();
      $(window).trigger('scroll');
      initStateButtonsHandler();
    }).reload();
  });

  // Relay points NL
  if(cube.$id('relay-point-search'))
    cube.$id('relay-point-search').addEventListener('click', search);

  if(cube.$id('relayinput')) {
    cube.$id('relayinput').addEventListener('keydown', (e) => {
      if(e.which === 13) {
        search(e);
        e.stopPropagation();
        e.preventDefault();
      }
    });
  }

  if(cube.$id('search-input'))
    relayPointGeneric();

  // Change address
  cube.event.on('checkout:load-address', () => {
    cube.$('.checkout__shipping__home-delivery .checkout__shipping__store__layout').classList.add('checkout__shipping__store__layout--hidden');
  });

  // IF RETURN & EXCHANGE
  if (cube.$id('js-reex-delivery'))
    initShippingReex();

  // POC ONEFF -> TO IMPROVE/REMOVE
  if(cube.$('.checkout__shipping__oneff--notavailable')) {
    cube.$$('.dkt-checkout-primary-button').forEach(element => {
      element.disabled = true;
      element.classList.add('cta-v2--disabled');
    });
  }
};



// WEBPACK FOOTER //
// ./src/modules-es5/checkout/shipping/shipping.js